import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

//
import Button from "../../../components/button/Button";
import IMGRIGHT from "../../../assets/images/main-top-right.jpg";

export default function MainTop() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  function handleNavigate(url) {
    navigate(url);
  }

  return (
    <StyledMainTop>
      <div className="left__frame"></div>
      <div className="container">
        <div className="main-top__wrap">
          <div className="main-top__left">
            <h1 dangerouslySetInnerHTML={{ __html: t("homeTopTitle") }} />
            <p dangerouslySetInnerHTML={{ __html: t("homeTopText") }} />
            <div className="main-top__button">
              <Button hover='white' onClick={() => handleNavigate("/contact")}>
                {t("homeTopBtn")}
              </Button>
            </div>
          </div>
          <div className="main-top__right"></div>
        </div>
      </div>
      <div className="main-top-img">
        <img src={IMGRIGHT} alt="IMGRIGHT" />
      </div>
    </StyledMainTop>
  );
}

const StyledMainTop = styled.section`
  position: relative;

  .left__frame {
    position: absolute;
    height: 100%;
    width: 85%;
    left: 0;
    background: linear-gradient(79deg, #274760 0%, rgba(39, 71, 96, 0) 90%);
    z-index: 2;
  }

  .main-top-img {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    line-height: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .main-top {
    &__wrap {
      display: grid;
      grid-template-columns: 1fr;
    }

    &__left {
      display: flex;
      flex-direction: column;
      padding: 140px 0 160px;
      transform: translate(0, 0);
      z-index: 3;

      h1 {
        color: var(--title);
        color: var(--white);
        font-size: var(--fs-page-title);
        font-style: normal;
        font-weight: var(--fw-semibold);
        line-height: var(--lh-title);
        margin-bottom: 78px;
      }

      p {
        color: var(--text);
        color: var(--white);
        font-size: var(--fs-body-lg);
        font-style: normal;
        font-weight: var(--fw-medium);
        line-height: var(--lh-body-lg);
        margin-bottom: 84px;

        b {
          color: var(--title);
          color: var(--white);
          font-weight: 700;
        }
      }
    }

    &__right {
    }
  }
`;
